import { Briefcase } from 'lucide-react';
import type { FeatureModule } from '../../app/feature-module';
import { PipelinePage } from './pages/PipelinePage';

export const pipelineModule: FeatureModule = {
  id: 'pipeline',
  label: 'Pipeline',
  icon: Briefcase,
  basePath: '/pipeline',
  routes: [{ path: '/', element: <PipelinePage /> }],
  sidebarSection: 'workspace',
  requiredPermission: 'leads.read',
};
